<template>
  <div style="position: relative;display: inline-block;float: right;">
    <input type="text" v-model="search_mod" :placeholder="placeholder" @change="search" />
    <i class="search"></i>
  </div>
</template>

<script>
import debounce from "lodash.debounce"; 
export default {
  name: "searchInput",
  props:{
      placeholder:{
          type:String
      }
  },
  data() {
    return {
      search_mod:""
    };
  },
  watch: {
      search_mod: function () {
      this.debouncedSeaech()
    }
  },
  created() {
      this.debouncedSeaech = debounce(this.setSearch, 500)
  },
  methods: {
    search(){
        this.$emit("search")
    },
    setSearch(){
        this.$emit("setSearch",this.search_mod)
    }
  },
};
</script>

<style lang="less" scoped>
input {
  width: 222px;
  height: 34px;
  line-height: 36px;
  border: 1px solid rgba(184, 196, 206, 1);
  border-radius: 2px;
  padding: 0 10px;
  padding-right: 26px;
  background: #f5f4f4;
}
input:focus {
  outline: none;
  border: 1px solid #454545;
}
.search {
  background: url("../assets/imgs/project/sswj.png") center no-repeat;
  position: absolute;
  height: 19px;
  width: 19px;
  display: block;
  top: 8px;
  right: 10px;
}
</style>